import { render, staticRenderFns } from "./ReportSpaceSPBU.vue?vue&type=template&id=8ea1f138"
import script from "./ReportSpaceSPBU.vue?vue&type=script&lang=js"
export * from "./ReportSpaceSPBU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports